import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { ProgrammeType } from '../types';

import { updateProgramme as putProgramme } from '@api';
import { CurriculumQueryKeys } from '@services';

export const useUpdateProgramme = (
    programmeId: number | undefined,
    successMessage: string,
    errorMessage?: string,
    onSuccessCallback?: () => void,
    onErrorCallback?: () => void,
) => {
    const queryClient = useQueryClient();

    const { mutate: updateProgramme, isPending: isUpdating } = useMutation({
        mutationFn: (data: Partial<ProgrammeType>) =>
            putProgramme(programmeId, data),
        onSuccess: () => {
            enqueueSnackbar(successMessage, {
                key: 'edit-programme-success',
                testId: 'edit-programme-success',
                variant: 'curriculumSnackbar',
                severity: 'success',
            });

            queryClient.invalidateQueries({
                queryKey: [`${CurriculumQueryKeys.PROGRAMME}-${programmeId}`],
            });

            if (onSuccessCallback) onSuccessCallback();
        },
        onError: (error: Error) => {
            enqueueSnackbar(error?.message, {
                title:
                    errorMessage || 'There was an error editing the programme',
                key: 'edit-programme-error',
                testId: 'edit-programme-error',
                variant: 'curriculumSnackbar',
                severity: 'error',
            });

            if (onErrorCallback) onErrorCallback();
        },
    });

    return { updateProgramme, isUpdating };
};
